import type { EcommerceItemPrice } from '@/types/shared/player-config'

export type Skin = {
  id: string
  name: string
  description: string
  imageUrl: string
  price: EcommerceItemPrice[]
  category: SKIN_CATEGORIES
}

export enum SKIN_CATEGORIES {
  BASIC = 'basic',
  PREMIUM = 'premium',
  EPIC = 'epic'
}